
<script>
import HighlightedText from "@/components/atoms/highlighted-text";
import LinkTo from "@/components/atoms/link-to";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import Icon from "@/components/atoms/icon";
export default {
  name: "ShopSuggestionList",
  components: {
    LinkTo,
    List,
    ListItem,
    Icon,
    HighlightedText
  },
  props: {
    keyWord: {
      type: String,
      default: null
    },
    shops: {
      type: Array,
      default: null
    }
  },
  data() {
    return { maxShopsNumber: 3 };
  },
  computed: {
    shopsToDisplay({ shops }) {
      const maxShopsToDisplay = [];
      shops.map((shop, index) => {
        if (index < this.maxShopsNumber) {
          maxShopsToDisplay.push(shop);
        }
      });
      return maxShopsToDisplay;
    }
  }
};
</script>
<template>
  <div>
    <List
      v-for="shop in shopsToDisplay"
      :key="shop.id"
    >
      <ListItem class="c-shop-suggestion-list__item">
        <div class="c-shop-suggestion-list__item-label">
          <Icon
            name="location"
            size="sm"
            class="u-mr-xxs"
          />
          <HighlightedText
            :key-word="keyWord"
            :entire-word="shop.attributes.nom"
          />
        </div>
        <LinkTo
          class="c-shop-suggestion-list__item-link"
          :to="`/magasins/${shop.attributes.alias_web}-m-${shop.id}`"
        >
          Plus d'infos
        </LinkTo>
      </ListItem>
    </List>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shop-suggestion-list.scss";
</style>
